import React, {  useState } from 'react'
import { Button, Grid, Header, Segment, Portal, Label, Icon, List } from 'semantic-ui-react'
import SignOut from "../auth/SignOut"
import {  auth } from '../App';
import Help from './Help';

export default function MenuItem ({score, scores}) {
  
  const [open, setOpen] = useState(false)
  
  const handleClose = () => {
    setOpen(false)
  }
  const handleOpen = () => {
    setOpen(true)
  }
  
    return (
      <Grid relaxed columns={4}>
        <Grid.Column>
          <Button
            content='LeaderBoard'
            disabled={open}
            floated = "center"
            onClick={handleOpen}
            style = {{ background : "grey"}}
          />

          <Portal onClose={handleClose} open={open}>
            <Segment
              style={{
                left: '40%',
                position: 'fixed',
                top: '30%',
                zIndex: 1000,
              }}
            >
              <Header>Leaderboard</Header>
              <List items={scores && scores.map(scoreid => [scoreid.nick , "  highscore: " ,  scoreid.lasthighscore])} style={{ color: "grey" }} />
              <Button
                content="return to game"
                negative
                onClick={handleClose}
              />
            </Segment>
          </Portal>
        </Grid.Column>
        <Grid.Column>
        <Help></Help>
        </Grid.Column>
        <Grid.Column>
        <SignOut auth ={auth} />
        </Grid.Column>

        <Grid.Column>
        <Label>
          <Icon name='winner' /> Score: {score}
        </Label>
        </Grid.Column>

        
      </Grid>
    );
  };
